// extracted by mini-css-extract-plugin
export default {"Topic":"styles_Topic__4KvJY","Heading":"styles_Heading__ejI75","Toggle":"styles_Toggle__e24xr","QContainer":"styles_QContainer__MkKh5"};